exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-wandering-cubes {\r\n    top: 50%;\r\n    margin: auto;\r\n    width: 40px;\r\n    height: 40px;\r\n    position: relative;\r\n}\r\n\r\n.sk-wandering-cubes .sk-cube {\r\n    width: 10px;\r\n    height: 10px;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    animation: sk-wanderingCube 1.8s ease-in-out -1.8s infinite both;\r\n}\r\n\r\n.sk-wandering-cubes .sk-cube2 {\r\n    animation-delay: -0.9s;\r\n}\r\n\r\n@keyframes sk-wanderingCube {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n    25% {\r\n        transform: translateX(30px) rotate(-90deg) scale(0.5);\r\n    }\r\n    50% {\r\n        /* Hack to make FF rotate in the right direction */\r\n        transform: translateX(30px) translateY(30px) rotate(-179deg);\r\n    }\r\n    50.1% {\r\n        transform: translateX(30px) translateY(30px) rotate(-180deg);\r\n    }\r\n    75% {\r\n        transform: translateX(0) translateY(30px) rotate(-270deg) scale(0.5);\r\n    }\r\n    100% {\r\n        transform: rotate(-360deg);\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/shared/spinner/spinkit-css/sk-wandering-cubes.css
// module id = ../../../../../src/app/shared/spinner/spinkit-css/sk-wandering-cubes.css
// module chunks = main